// Group III. 語氣與情態 Modality and Mood
// Based on "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group3Data = {
  id: "group_3",
  title: {
    tc: "語氣與情態",
    sc: "语气与情态",
    en: "Modality and Mood"
  },
  subtitle: {
    tc: "Modality and Mood",
    sc: "Modality and Mood",
    en: "Modality and Mood"
  },
  icon: "🎭",
  difficulty: "intermediate",
  color: "from-purple-500 to-purple-600",
  topics: [
    {
      id: "modals_ability",
      title: {
        tc: "情態動詞（能力等）",
        sc: "情态动词（能力等）",
        en: "Modals: Ability/Possibility"
      },
      description: {
        tc: "學習表達能力和可能性的情態動詞",
        sc: "学习表达能力和可能性的情态动词",
        en: "Learn modal verbs for expressing ability and possibility"
      },
      icon: "💪",
      difficulty: "intermediate",
      examples: [
        {
          id: "modals_ability_1",
          sentence: "I can swim.",
          analysis: "I (S) can swim (V).",
          translation: {
            tc: "我會游泳。",
            sc: "我会游泳。",
            en: "I can swim."
          }
        },
        {
          id: "modals_ability_2",
          sentence: "She could solve it yesterday.",
          analysis: "She (S) could solve (V) it (O) yesterday (M).",
          translation: {
            tc: "她昨天能解決它。",
            sc: "她昨天能解决它。",
            en: "She could solve it yesterday."
          }
        },
        {
          id: "modals_ability_3",
          sentence: "We might be late.",
          analysis: "We (S) might be (V) late (C).",
          translation: {
            tc: "我們可能會遲到。",
            sc: "我们可能会迟到。",
            en: "We might be late."
          }
        },
        {
          id: "modals_ability_4",
          sentence: "He may know the answer.",
          analysis: "He (S) may know (V) the answer (O).",
          translation: {
            tc: "他可能知道答案。",
            sc: "他可能知道答案。",
            en: "He may know the answer."
          }
        },
        {
          id: "modals_ability_5",
          sentence: "They must be tired.",
          analysis: "They (S) must be (V) tired (C).",
          translation: {
            tc: "他們一定很累。",
            sc: "他们一定很累。",
            en: "They must be tired."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：情態 + 動詞原形；語氣表能力/可能/必然。",
        sc: "要点：情态 + 动词原形；语气表能力/可能/必然。",
        en: "Key points: Modal + base verb; expresses ability/possibility/necessity."
      }
    },
    {
      id: "modals_obligation",
      title: {
        tc: "情態動詞（義務/建議）",
        sc: "情态动词（义务/建议）",
        en: "Modals: Obligation/Advice"
      },
      description: {
        tc: "學習表達義務和建議的情態動詞",
        sc: "学习表达义务和建议的情态动词",
        en: "Learn modal verbs for expressing obligation and advice"
      },
      icon: "📋",
      difficulty: "intermediate",
      examples: [
        {
          id: "modals_obligation_1",
          sentence: "You must wear a seatbelt.",
          analysis: "You (S) must wear (V) a seatbelt (O).",
          translation: {
            tc: "你必須繫安全帶。",
            sc: "你必须系安全带。",
            en: "You must wear a seatbelt."
          }
        },
        {
          id: "modals_obligation_2",
          sentence: "You should see a doctor.",
          analysis: "You (S) should see (V) a doctor (O).",
          translation: {
            tc: "你應該去看醫生。",
            sc: "你应该去看医生。",
            en: "You should see a doctor."
          }
        },
        {
          id: "modals_obligation_3",
          sentence: "We have to leave now.",
          analysis: "We (S) have to leave (V) now (M).",
          translation: {
            tc: "我們現在必須離開。",
            sc: "我们现在必须离开。",
            en: "We have to leave now."
          }
        },
        {
          id: "modals_obligation_4",
          sentence: "You ought to apologize.",
          analysis: "You (S) ought to apologize (V).",
          translation: {
            tc: "你應該道歉。",
            sc: "你应该道歉。",
            en: "You ought to apologize."
          }
        },
        {
          id: "modals_obligation_5",
          sentence: "You don't have to come early.",
          analysis: "You (S) do not have to come (V) early (M).",
          translation: {
            tc: "你不必早來。",
            sc: "你不必早来。",
            en: "You don't have to come early."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：must/should/ought to/have to；語氣強度不同，注意義務 vs 不必要。",
        sc: "要点：must/should/ought to/have to；语气强度不同，注意义务 vs 不必要。",
        en: "Key points: must/should/ought to/have to; different strength levels, obligation vs unnecessary."
      }
    }
  ]
};
